import { render, staticRenderFns } from "./ReportPreviewButton.vue?vue&type=template&id=887bf596&scoped=true&"
import script from "./ReportPreviewButton.vue?vue&type=script&lang=js&"
export * from "./ReportPreviewButton.vue?vue&type=script&lang=js&"
import style0 from "./ReportPreviewButton.vue?vue&type=style&index=0&id=887bf596&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "887bf596",
  null
  
)

export default component.exports